export const GET_GEN_ARTS = 'GET_GEN_ARTS'
export const GET_GEN_ARTS_SUCCESS = 'GET_GEN_ARTS_SUCCESS'
export const GET_GEN_ARTS_FAILED = 'GET_GEN_ARTS_FAILED'

export const LOCK_GET_CACHED_GEN_ARTS = 'LOCK_GET_CACHED_GEN_ARTS'
export const GET_CACHED_GEN_ARTS = 'GET_CACHED_GEN_ARTS'
